if (!customElements.get('wls-promo-bar')) {
  class WLSPromoBar extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'is-active',
        hidden: 'hidden',
        messagesContainer: '.wls-promo-bar__messages',
        trackList: '.wls-promo-bar__track',
        slideItem: '.wls-promo-bar__slide',
        previousButton: '.wls-promo-bar__nav--prev',
        nextButton: '.wls-promo-bar__nav--next',
      };

      this.currentIndex = 0;
      this.autoplayTimer = null;

      this.boundHandlePrevClick = this.handlePrevClick.bind(this);
      this.boundHandleNextClick = this.handleNextClick.bind(this); 
    }
    
    get elements() {
      const $ = (selector) => this.querySelector(selector);
      const $$ = (selector) =>
        Array.from(this.querySelectorAll(selector));
      
      return {
        messagesContainer: $(this.classes.messagesContainer),
        trackList: $(this.classes.trackList),
        slideItems: $$(this.classes.slideItem),
        previousButton: $(this.classes.previousButton),
        nextButton: $(this.classes.nextButton),
      };
    }
    
    connectedCallback() {
      const {
        messagesContainer,
        trackList,
        slideItems,
      } = this.elements;
      
      if (
        !messagesContainer ||
        !trackList ||
        slideItems.length === 0
      ) {
        return;
      }
      
      const activeFromMarkup = slideItems.findIndex((element) =>
        element.classList.contains(this.classes.active)
    );
    
    this.currentIndex = activeFromMarkup >= 0
    ? activeFromMarkup
    : 0;
    
    this.intervalMs = 3000;
    
    this.setActiveSlide(this.currentIndex);
    this.updateNavVisibility();
    this.bindEventListeners();
    this.startAutoplay();
  }
  
  disconnectedCallback() {
    this.stopAutoplay();
    
    const {
      previousButton,
      nextButton,
    } = this.elements;
    
    if (previousButton) {
      previousButton.removeEventListener('click', this.boundHandlePrevClick);
    }
    
    if (nextButton) {
      nextButton.removeEventListener('click', this.boundHandleNextClick);
    }
  }
  
  handlePrevClick = (event) => {
    event.preventDefault();
    this.showPrevious();
    this.startAutoplay();
  };

  handleNextClick = (event) => {
    event.preventDefault();
    this.showNext();
    this.startAutoplay();
  };

  bindEventListeners() {
    const {
        previousButton,
        nextButton,
      } = this.elements;

      if (previousButton) {
        previousButton.addEventListener('click', this.boundHandlePrevClick);
      }

      if (nextButton) {
        nextButton.addEventListener('click', this.boundHandleNextClick);
      }
    }

    updateNavVisibility() {
      const { previousButton, nextButton, slideItems } = this.elements;

      const multipleSlides = slideItems.length > 1;

      [previousButton, nextButton].forEach((button) => {
        if (!button) return;

        button.classList.toggle(this.classes.hidden, !multipleSlides);
      });
    }

    setActiveSlide(index) {
      const slides = this.elements.slideItems;
      const total = slides.length;

      if (total === 0) return;

      this.currentIndex = ((index % total) + total) % total;

      slides.forEach((element, i) => {
        const isActive = i === this.currentIndex;

        element.classList.toggle(this.classes.active, isActive);
        element.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    showNext() {
      this.setActiveSlide(this.currentIndex + 1);
    }

    showPrevious() {
      this.setActiveSlide(this.currentIndex - 1);
    }

    startAutoplay() {
      if (this.autoplayTimer || this.elements.slideItems.length <= 1) {
        return;
      }

      this.autoplayTimer = setInterval(
        () => this.showNext(),
        this.intervalMs
      );
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;

      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  customElements.define('wls-promo-bar', WLSPromoBar);
}
